import { createSelector } from "reselect";

export const commonSelector = state => state.common;

const getDefaultSelector = state => state.dashboard;

const getDashboardNotesSelector = state => state.dashboard.notes;

export const authSelector = state => state.auth;

const getTransformedState = data => {
	//Do all the tranformations and calculations here
	const transformedData = data;
	return transformedData;
};

export const dashboardProfileSelector = createSelector(
	getDefaultSelector, //pick off a piece of state
	getTransformedState // last argument is the function that has our select logic -- in our case its pretty simple logic of extracting props.
);

export const dashboardNotesSelector = createSelector(
	getDashboardNotesSelector, //pick off a piece of state
	getTransformedState // last argument is the function that has our select logic -- in our case its pretty simple logic of extracting props.
);



// WEBPACK FOOTER //
// ./src/features/dashboard/selectors/index.js